import React from 'react';
import Icon from '../../../components/AppIcon';

const SummaryStats = ({ transactions }) => {
  // Calculate statistics
  const totalTransactions = transactions?.length || 0;
  const confirmedTransactions = transactions?.filter(tx => tx?.status === 'confirmed')?.length || 0;
  const pendingTransactions = transactions?.filter(tx => tx?.status === 'pending')?.length || 0;
  const failedTransactions = transactions?.filter(tx => tx?.status === 'failed')?.length || 0;
  
  const totalStorage = transactions?.reduce((acc, tx) => {
    if (tx?.fileSize) {
      const sizeNum = parseFloat(tx?.fileSize?.replace(' MB', ''));
      return acc + sizeNum;
    }
    return acc;
  }, 0);

  const stats = [
    {
      title: 'Total Notarizations',
      value: totalTransactions,
      icon: 'Archive',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      description: 'Total archived webpages'
    },
    {
      title: 'Successful',
      value: confirmedTransactions,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      description: 'Successfully confirmed'
    },
    {
      title: 'Pending',
      value: pendingTransactions,
      icon: 'Clock',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100',
      description: 'Awaiting confirmation'
    },
    {
      title: 'Storage Used',
      value: `${totalStorage?.toFixed(1)} MB`,
      icon: 'HardDrive',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      description: 'Total storage consumed'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-muted-foreground">{stat?.title}</p>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{stat?.description}</p>
            </div>
          </div>

          {/* Progress bar for storage */}
          {stat?.title === 'Storage Used' && (
            <div className="mt-4">
              <div className="flex justify-between text-xs text-muted-foreground mb-1">
                <span>Used</span>
                <span>1 GB limit</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`h-2 rounded-full ${stat?.color?.replace('text-', 'bg-')}`}
                  style={{ width: `${Math.min((totalStorage / 1000) * 100, 100)}%` }}
                />
              </div>
            </div>
          )}

          {/* Success rate for successful transactions */}
          {stat?.title === 'Successful' && totalTransactions > 0 && (
            <div className="mt-4">
              <div className="flex justify-between text-xs text-muted-foreground mb-1">
                <span>Success Rate</span>
                <span>{Math.round((confirmedTransactions / totalTransactions) * 100)}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className="h-2 rounded-full bg-green-600"
                  style={{ width: `${(confirmedTransactions / totalTransactions) * 100}%` }}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummaryStats;